<ngx-spinner type="timer">
  <p *ngIf="spinnerService.getText()" style="color:white">{{ spinnerService.getText() }}</p>
</ngx-spinner>
<router-outlet></router-outlet>
  